import { useShallow } from 'zustand/react/shallow';
import { PurchaseChannel } from '@types';
import { useChallengeFormStore } from '../../NewChallengeForm.store';

export const usePurchaseChannel = () => {
  return useChallengeFormStore(
    useShallow((s) => ({
      purchaseChannel: s.challenge.purchaseChannel,
    })),
  );
};

export const usePurchaseChannelActions = () => {
  const updateChallengeForm = useChallengeFormStore(
    (s) => s.updateChallengeForm,
  );

  const setPurchaseChannel = (purchaseChannel: PurchaseChannel) =>
    updateChallengeForm({ purchaseChannel });

  return { setPurchaseChannel };
};
